import { getPageNumbersWithPhoneQuestion } from '../../Helpers/components';
import { ComponentTypes } from '../../Data/Components';
import { isSupplierMatch } from '../../Helpers/supplierMatches';

const isPredefinedSupplierRequiringTCPALegalStatement = (formSettings) =>
  Boolean(
    formSettings.forms.metadata.gdpr_supplier_id &&
      (formSettings.forms.metadata?.showCustomerMatchesOnThankYouPage ||
        Object.values(formSettings.forms.page_components).some(isSupplierMatch))
  );

/**
 * isSupplierMatchingLegalStatementRequired
 *
 * There are currently two situations requiring a TCPA Legal Statement:
 * 1. The form has a predefined supplier AND customer matches are requested at some point in the form.
 * 2. The form is showing a Select and Connect component.
 *
 * If there is the possibility of either of the above occurring, we will need to request these statements at the beginning of the form journey.
 */
export const isSupplierMatchingLegalStatementRequired = (formSettings) =>
  Boolean(
    isPredefinedSupplierRequiringTCPALegalStatement(formSettings) ||
      Object.values(formSettings.forms.page_components).some(
        (component) =>
          component.component.type === ComponentTypes.SELECT_AND_CONNECT
      )
  );

export const isOptOut = (components) => {
  let isEmailOptOut = false;
  let isSmsOptOut = false;
  let isOttOptOut = false;

  Object.values(components).forEach((component) => {
    if (
      component?.component?.mappedQuestionId === 'sms_marketing_consent_opt_out'
    ) {
      isSmsOptOut = true;
    }
    if (
      component?.component?.mappedQuestionId === 'marketing_consent_opt_out'
    ) {
      isEmailOptOut = true;
    }
    if (
      component?.component?.mappedQuestionId === 'ott_marketing_consent_opt_out'
    ) {
      isOttOptOut = true;
    }
  });
  return { isEmailOptOut, isSmsOptOut, isOttOptOut };
};

// TODO Investigate if this legal statement is valid, and thus able to remove initial request for it
// const buildLegalStatement = (formSettings) => ({
//   consentedSuppliersHash:
//     formSettings.apiEagle.legal_statement.consented_suppliers_hash,
//   statement: formSettings.apiEagle.legal_statement.statement,
//   consentedLegalStatementHash:
//     formSettings.apiEagle.legal_statement.consented_legal_statement_hash,
//   suppliersModal: formSettings.apiEagle.legal_statement.suppliers_modal,
// });
export const isLegalStatementOnFirstPage = (components) => {
  const pageNumbersWithPhoneQuestion =
    getPageNumbersWithPhoneQuestion(components);
  return pageNumbersWithPhoneQuestion.includes(0);
};

const isDynamicNewsletter = (component) =>
  component?.component?.type === ComponentTypes.NEWSLETTER_SIGNUP &&
  component?.component?.additionalSettings?.is_dynamic;

export const isDynamicNewsletterPresent = (components) =>
  Object.values(components).some(isDynamicNewsletter);
